import { Box, Typography } from "@mui/material";

import AmountInput from "./AmountInput";

import { useAccount } from "../../context/AccountProvider";
import { useArrangement } from "../../context/ArrangementProvider";

const ArrangementCalculator = ({ setErrorMessage }) => {
  /* The repayment calculator component */

  const { plan } = useArrangement();

  const { useGetAccount } = useAccount();
  const { account } = useGetAccount();

  return plan && (
    <Box
      sx={{
        textAlign: "center",
        borderRadius: 0,
        backgroundColor: "primary.dark",
        color: "primary.contrastText",
        py: 1,
      }}
    >
      <AmountInput setErrorMessage={setErrorMessage} />
      <Typography sx={{ m: 2, mt: 1 }}>
          <Box sx={{ fontSize: 14, ml: 1, pr: 1 }}>
          Your repayment plan will cover your minimum payment and overdue amounts (of <b>£{account?.arrearsAmount.toFixed(2)})</b> for the <br /> duration of the plan.
          However, you may still have some remaining balance that needs to be paid according your contract terms.
          </Box>
        </Typography>
    </Box>
  );
};

export default ArrangementCalculator;
